import { Icon } from './_Icon';
export const BellIcon = (props) => (
  <Icon
    {...props}
    d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9 M13.73 21a2 2 0 0 1-3.46 0"
  />
);
